/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { Col } from "reactstrap";
import {
  credDeleteSuccess,
  creditSelf,
} from "../../../slices/admin/CreditDebit/CreditDebitSlice";
import { fetchData } from "../../../slices/authSlice/dataSlice";
import AdminPageLayout from "../../../layouts/AdminPageLayout";
import SimpleInputField from "../../../components/FormComponent/InputField";
import ButtonComponent from "../../../components/common/buttonComponent";
import { popButtonDefaultDesc } from "../../../components/common/constant";

const CreditSelfAdmin = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [creditAmount, setCreditAmount] = useState("");
  const [tpin, setTpin] = useState("");
  const { user: currentUser } = useSelector((state) => state.user);
  const { token: Usertoken } = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(fetchData({ Usertoken, currentUser }));
  }, [dispatch]);

  const AddMoney = () => {
    setLoading(true);
    dispatch(
      creditSelf({
        currentUser,
        Usertoken,
        creditAmount,
        tpin,
      })
    )
      .unwrap()
      .then((res) => {
        if (res.status.type === "success") {
          toast.success("Balance added successfully");
          props.setOpenWalletModal(false);
          dispatch(fetchData({ Usertoken, currentUser }));
          dispatch(credDeleteSuccess());
          setLoading(false);
        } else {
          toast.error(res.data.message);
          setLoading(false);
        }
      })
      .catch((res) => {
        toast.error(res);
        setLoading(false);
      });
  };

  return (
    <AdminPageLayout
      loading={loading}
      isBreadCrumbs={false}
      isCardView={false}
      isPadding={false}
    >
      {/* <Row> */}
      <Col md="12">
        <SimpleInputField
          label="Enter Amount"
          name="toupAmount"
          value={creditAmount}
          onChangeAction={setCreditAmount}
        />
      </Col>
      <Col md="12">
        <SimpleInputField
          label="TPin"
          name="toupAmount"
          value={tpin}
          onChangeAction={setTpin}
          fieldType='password'
        />
      </Col>
      <Col className="mt-2 text-end">
        <ButtonComponent
          popDescription={popButtonDefaultDesc("add money")}
          buttonData={{
            // type: "submit",
            disabled: loading,
            className: "me-2",
            color: "tab",
          }}
          onConfirmAction={AddMoney}
          loading={loading}
        >
          Add Money
        </ButtonComponent>
      </Col>
      {/* </Row> */}
    </AdminPageLayout>
  );
};

export default CreditSelfAdmin;
